import React from "react";
import Modal from "../../../components/modal";
import {CancelButton, FlexContainer, SubmitButton, Text} from "../../../design";
import getformatteddate from "../../../utils/getformatteddate";
import { AmountDivideByHundred } from "../../../helper";
import currencyformatter from "../../../utils/currencyformatter";


const AutoPayConfirmationModal = (props) => {
  const { setAutoPayConfirmation, chargeById, autoPayConfirmation, partialPaymentDetails, paymentDueDate, currencyName } = props;
  const dueDate = paymentDueDate ? getformatteddate(paymentDueDate,  partialPaymentDetails?.account && partialPaymentDetails?.account.timezone) : "N.A.";
  const pendingAmount = partialPaymentDetails?.pendingAmount ? currencyformatter(AmountDivideByHundred(partialPaymentDetails?.pendingAmount), currencyName) : "N.A."
  return (
    <Modal isOpen={autoPayConfirmation?.open}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
              <Text
                fontSize="20px"
                fontWeight='600'
              >
              Enable Autopay for Pending Payment?
            </Text>
            <Text fontSize="16px" textAlign="center" paddingX="14px">
              Would you like to enable Autopay by saving this payment method to complete your 
              Pending Amount on Due date: {dueDate} for pending amount: {pendingAmount}
            </Text>
            <FlexContainer
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <CancelButton
                onClick={() => {
                  setAutoPayConfirmation((prev) => ({ data: prev?.data, confirmation: false, open: false }));
                  chargeById(autoPayConfirmation?.data, 'REGULAR');
                }}
                type="button"
              >PAY</CancelButton>
              <SubmitButton
                onClick={() => {
                  setAutoPayConfirmation((prev) => ({ data: prev?.data, confirmation: true, open: false }));
                  chargeById(autoPayConfirmation?.data, 'AUTOPAY');
                }}
                type="button"
              >Enable & Pay</SubmitButton>
            </FlexContainer>
      </FlexContainer>
    </Modal>
  )
};

export default AutoPayConfirmationModal;
